import React from 'react';
import { Typography, Box, Button, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon, BarChart as BarChartIcon, Calculate as CalculateIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function Level1Header({ onRefresh, tradeDate, onCalculate, calculating = false }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
      {/* Left: Icon + Title */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{
          width: 42, height: 42, borderRadius: 1.5,
          background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 4px 14px rgba(6, 182, 212, 0.3)',
        }}>
          <BarChartIcon sx={{ fontSize: 22, color: '#fff' }} />
        </Box>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ fontSize: '1.35rem', fontWeight: 800, color: '#1e293b', letterSpacing: -0.3 }}>
              {t('marketBreadth.title')}
            </Typography>
            {tradeDate && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, bgcolor: '#f1f5f9', px: 1, py: 0.3, borderRadius: 1.5 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#06b6d4', boxShadow: '0 0 6px #06b6d4' }} />
                <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#475569' }}>
                  {tradeDate}
                </Typography>
              </Box>
            )}
          </Box>
          <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: 500 }}>
            {t('marketBreadth.subtitle')}
          </Typography>
        </Box>
      </Box>

      {/* Right: Controls */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          variant="contained"
          startIcon={calculating ? <CircularProgress size={16} color="inherit" /> : <CalculateIcon sx={{ fontSize: 16 }} />}
          onClick={onCalculate}
          disabled={calculating}
          sx={{ textTransform: 'none', fontSize: 13, fontWeight: 600, borderRadius: '4px',
            bgcolor: '#06b6d4', color: '#fff',
            '&:hover': { bgcolor: '#0891b2' },
            '&:disabled': { bgcolor: '#94a3b8', color: '#fff' },
            '& .MuiButton-startIcon': { mr: 0.5 } }}
        >
          {calculating ? t('marketBreadth.calculating') : t('marketBreadth.calculateNow')}
        </Button>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon sx={{ fontSize: 16 }} />}
          onClick={onRefresh}
          sx={{ textTransform: 'none', fontSize: 13, fontWeight: 600, borderRadius: '4px',
            color: '#64748b', borderColor: '#e2e8f0',
            '&:hover': { bgcolor: '#f8fafc', borderColor: '#cbd5e1' },
            '& .MuiButton-startIcon': { mr: 0.5 } }}
        >
          {t('marketBreadth.refresh')}
        </Button>
      </Box>
    </Box>
  );
}

export default Level1Header;
